import React, { useEffect, useState } from 'react';
import { ProjectCard } from './ProjectCard';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, LayoutGridIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
const CATEGORIES = ['All', 'Brand Identity', 'eCommerce', 'Booking', 'Rent a Car', 'Rent a Boat', 'Custom-Special'];
const PROJECTS = [{
  id: 'socialamour',
  title: 'SocialAmour',
  description: "Premium social media agency showcase where I'm the sole web developer powering the core team for Hollywood A-listers like Selma Hayek, Luke Evans, and world-class global brands – delivering razor-sharp, modern service presentation.",
  categories: ['Brand Identity'],
  url: 'https://socialamour.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://socialamour.com/'
}, {
  id: 'hmd',
  title: 'HMD',
  description: "Bespoke London-based architect's showcase featuring bold visual identity, smooth micro-interactions, and impeccable minimal design crafted for creative excellence.",
  categories: ['Brand Identity'],
  url: 'https://hmd.studio/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://hmd.studio/'
}, {
  id: 'abc',
  title: 'ABC Interijer',
  description: 'Renowned Croatian interior design firm specializing in premium kitchens and retail spaces, featuring sophisticated eCommerce platform with curated product catalog and visual-first browsing experience for their established luxury clientele.',
  categories: ['eCommerce'],
  url: 'https://abc-interijer.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://abc-interijer.hr/'
}, {
  id: 'anic',
  title: 'Anić Holding',
  description: 'Corporate masterpiece with interactive map featuring 400+ geo-pinned locations, advanced search by viewport, custom pin data visualization, and seamless company overview integration.',
  categories: ['Custom-Special'],
  url: 'https://anic-holding.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://anic-holding.com/'
}, {
  id: 'warans',
  title: "Waran's Fine Art",
  description: 'Elegant fine art gallery with secure purchasing and custom My Account dashboard displaying real-time artwork value appreciation graphs – fully bespoke WooCommerce development.',
  categories: ['eCommerce', 'Custom-Special'],
  url: 'https://www.waransfineart.co.uk/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://www.waransfineart.co.uk/'
}, {
  id: 'patela',
  title: 'Poliklinika Patela',
  description: 'Medical clinic website with professional aesthetics and patient-focused UX.',
  categories: ['Brand Identity'],
  url: 'https://www.poliklinika-patela.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://www.poliklinika-patela.hr/'
}, {
  id: 'gromela',
  title: 'Gromela Centar',
  description: 'Business center website with clean layout and comprehensive service overview.',
  categories: ['Brand Identity'],
  url: 'https://gromelacentar.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://gromelacentar.hr/'
}, {
  id: 'terranook',
  title: 'Terranook',
  description: 'Nature-inspired brand site with warm aesthetics and immersive storytelling.',
  categories: ['Brand Identity'],
  url: 'https://terranook.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://terranook.hr/'
}, {
  id: 'magicpulse',
  title: 'MagicPulse',
  description: 'Health supplement e-commerce with engaging product showcases and smooth checkout.',
  categories: ['eCommerce'],
  url: 'https://magicpulse.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://magicpulse.hr/'
}, {
  id: 'royal',
  title: 'Royal Lashes',
  description: 'Premium beauty e-commerce with fluid animations and seamless shopping experience.',
  categories: ['eCommerce'],
  url: 'https://www.royal-lashes.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://www.royal-lashes.hr/'
}, {
  id: 'walllab',
  title: 'Wall Lab',
  description: 'Wall decoration shop with visual product configurator and modern interface.',
  categories: ['eCommerce'],
  url: 'https://wall-lab.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://wall-lab.hr/'
}, {
  id: 'joka',
  title: 'Joka Studio',
  description: "Fashion eCommerce store following the owner's unique retro design vision – stylish clothing showcase with vintage-modern fusion and seamless shopping experience.",
  categories: ['eCommerce'],
  url: 'https://joka-studio.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://joka-studio.com/'
}, {
  id: 'zalagaonice',
  title: 'Zalagaonice',
  description: 'Pawn shop marketplace with search-driven browsing and detailed listings.',
  categories: ['eCommerce'],
  url: 'https://zalagaonice.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://zalagaonice.com/'
}, {
  id: 'swanky',
  title: 'Stay Swanky',
  description: "Zagreb's most popular modern hostel with a well-known bar and restaurant – booking platform featuring vibrant design, real-time availability, and the city's best social atmosphere.",
  categories: ['Booking'],
  url: 'https://stayswanky.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://stayswanky.com/'
}, {
  id: 'zlatnirat',
  title: 'Zlatni Rat Hotel',
  description: 'Zlatni Rat Bay premium hotel with streamlined reservation flow and elegant guest experience presentation.',
  categories: ['Booking'],
  url: 'https://zlatnirat-hotel.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://zlatnirat-hotel.hr/'
}, {
  id: 'valmik',
  title: 'Valmik Drive',
  description: 'Premium luxury car rental platform with real-time fleet availability, high-end vehicle showcase, and seamless booking process.',
  categories: ['Rent a Car'],
  url: 'https://valmikdrive.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://valmikdrive.com/'
}, {
  id: 'feluro',
  title: 'Feluro',
  description: 'Boat rental service with visual fleet showcase and easy reservation system.',
  categories: ['Rent a Boat'],
  url: 'https://feluro.hr/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://feluro.hr/'
}, {
  id: 'speedboat',
  title: 'Zadar Speedboat',
  description: 'Speedboat tours and rentals with adventure-focused design and quick booking.',
  categories: ['Rent a Boat'],
  url: 'https://zadar-speedboat.com/',
  imageUrl: 'https://image.thum.io/get/width/800/crop/533/noanimate/https://zadar-speedboat.com/'
}];
export function ProjectShowcase() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileSlideIndex, setMobileSlideIndex] = useState(0);
  const {
    t
  } = useLanguage();
  const CATEGORIES_DISPLAY = [{
    key: 'All',
    label: t.catAll
  }, {
    key: 'Brand Identity',
    label: t.catBrandIdentity
  }, {
    key: 'eCommerce',
    label: t.catEcommerce
  }, {
    key: 'Booking',
    label: t.catBooking
  }, {
    key: 'Rent a Car',
    label: t.catRentCar
  }, {
    key: 'Rent a Boat',
    label: t.catRentBoat
  }, {
    key: 'Custom-Special',
    label: t.catCustom
  }];
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);
  const filtered = activeCategory === 'All' ? PROJECTS : PROJECTS.filter(p => p.categories.includes(activeCategory));
  // Reset slider when category changes
  useEffect(() => {
    setMobileSlideIndex(0);
  }, [activeCategory]);
  const nextSlide = () => {
    setMobileSlideIndex(prev => (prev + 1) % filtered.length);
  };
  const prevSlide = () => {
    setMobileSlideIndex(prev => (prev - 1 + filtered.length) % filtered.length);
  };
  return <>
      <section id="projects" className="relative z-10 px-6 md:px-12 lg:px-20 py-24 md:py-32" data-id="element-305">
        <div className="max-w-[1400px] mx-auto" data-id="element-306">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="mb-10 md:mb-16" data-id="element-307">
            <div className="flex items-end justify-between mb-8 md:mb-10" data-id="element-308">
              <div data-id="element-309">
                <p className="text-secondary text-xs tracking-[0.2em] uppercase mb-4 font-light" data-id="element-310">
                  {t.projectsOverline}
                </p>
                <h2 className="text-3xl md:text-5xl font-display font-bold text-primary tracking-tight" data-id="element-311">
                  {t.projectsTitle}
                </h2>
              </div>
              <span className="hidden md:block text-secondary text-sm font-light" data-id="element-312">
                {PROJECTS.length} {t.projectsTotal}
              </span>
            </div>

            {/* Category Filter — Slightly larger on mobile */}
            <div className="flex flex-wrap gap-2 md:gap-3" data-id="element-313">
              {CATEGORIES_DISPLAY.map(cat => <button key={cat.key} onClick={() => setActiveCategory(cat.key)} className={`relative px-3 py-2 md:px-5 md:py-2.5 text-[11px] md:text-sm tracking-[0.1em] uppercase rounded-full border transition-all duration-300 ${activeCategory === cat.key ? 'text-primary border-primary/50 bg-primary/10 font-medium' : 'text-secondary border-secondary/25 hover:text-primary hover:border-primary/30 hover:bg-primary/5 font-light'}`} data-id="element-314">
                  {cat.label}
                </button>)}
            </div>
          </motion.div>

          {/* Project Display */}
          <AnimatePresence mode="wait" data-id="element-315">
            {isMobile ?
          // Mobile Slider
          <motion.div key={`mobile-${activeCategory}-${mobileSlideIndex}`} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} className="relative" data-id="element-316">
                {filtered.length > 0 && <ProjectCard {...filtered[mobileSlideIndex]} index={0} data-id="element-317" />}

                {/* Mobile Slider Controls */}
                {filtered.length > 1 && <div className="flex items-center justify-between mt-6 px-2" data-id="element-318">
                    <button onClick={prevSlide} className="w-10 h-10 rounded-full border border-border flex items-center justify-center hover:bg-white/5 transition-colors" data-id="element-319">
                      <ChevronLeftIcon className="w-5 h-5 text-secondary" data-id="element-320" />
                    </button>
                    <div className="text-xs text-secondary/50 font-light tracking-widest" data-id="element-321">
                      {mobileSlideIndex + 1} / {filtered.length}
                    </div>
                    <button onClick={nextSlide} className="w-10 h-10 rounded-full border border-border flex items-center justify-center hover:bg-white/5 transition-colors" data-id="element-322">
                      <ChevronRightIcon className="w-5 h-5 text-secondary" data-id="element-323" />
                    </button>
                  </div>}
              </motion.div> :
          // Desktop Grid (max 4)
          <motion.div key={`desktop-${activeCategory}`} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.4
          }} className="grid grid-cols-2 gap-x-12 gap-y-16" data-id="element-324">
                {filtered.slice(0, 4).map((project, index) => <ProjectCard key={project.id} {...project} index={index} data-id="element-325" />)}
              </motion.div>}
          </AnimatePresence>

          {/* View All Button */}
          {filtered.length > (isMobile ? 1 : 4) && <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mt-12 md:mt-16 flex justify-center" data-id="element-326">
              <button onClick={() => setIsModalOpen(true)} className="group relative flex items-center gap-3 px-8 py-4 rounded-full border border-border bg-surface/50 hover:bg-surface hover:border-secondary/50 transition-all duration-500 overflow-hidden" data-id="element-327">
                <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/5 to-primary/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" data-id="element-328" />
                <LayoutGridIcon className="w-4 h-4 text-primary relative z-10" data-id="element-329" />
                <span className="relative z-10 text-xs md:text-sm tracking-[0.15em] uppercase font-medium text-primary" data-id="element-330">
                  {t.projectsViewAll} {filtered.length} {t.projectsProjects}
                </span>
              </button>
            </motion.div>}
        </div>
      </section>

      {/* Fullscreen Projects Modal */}
      <AnimatePresence data-id="element-331">
        {isModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="fixed inset-0 z-[100] bg-background/95 backdrop-blur-xl overflow-y-auto" data-id="element-332">
            <div className="min-h-screen px-6 md:px-12 lg:px-20 py-24" data-id="element-333">
              <div className="max-w-[1400px] mx-auto" data-id="element-334">
                <div className="flex items-center justify-between mb-12 sticky top-0 bg-background/80 backdrop-blur-md py-4 z-20 border-b border-border/50" data-id="element-335">
                  <h2 className="text-2xl md:text-3xl font-display font-bold text-primary tracking-tight" data-id="element-336">
                    {t.projectsAllProjects}
                  </h2>
                  <button onClick={() => setIsModalOpen(false)} className="w-10 h-10 rounded-full border border-border flex items-center justify-center hover:border-secondary/40 hover:bg-white/5 transition-colors duration-300" data-id="element-337">
                    <XIcon className="w-4 h-4 text-primary" data-id="element-338" />
                  </button>
                </div>

                <div className="flex flex-wrap gap-2 md:gap-3 mb-12" data-id="element-339">
                  {CATEGORIES_DISPLAY.map(cat => <button key={`modal-${cat.key}`} onClick={() => setActiveCategory(cat.key)} className={`relative px-3 py-2 md:px-5 md:py-2.5 text-[11px] md:text-sm tracking-[0.1em] uppercase rounded-full border transition-all duration-300 ${activeCategory === cat.key ? 'text-primary border-primary/50 bg-primary/10 font-medium' : 'text-secondary border-secondary/25 hover:text-primary hover:border-primary/30 hover:bg-primary/5 font-light'}`} data-id="element-340">
                      {cat.label}
                    </button>)}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-id="element-341">
                  {filtered.map((project, index) => <ProjectCard key={`modal-${project.id}`} {...project} index={index} data-id="element-342" />)}
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}